import { setCookie } from "cookies-next/client";

export function ensureBackToPageCookie(cookieDomain: string) {
  const currentUrl = typeof window !== "undefined" ? window.location.href : "";

  setCookie("backToPage", currentUrl, {
    domain: cookieDomain,
    path: "/",
    secure: false,
  });
}
